module.exports = __webpack_public_path__ + "static/ClickedInSingapore-0d392b9fc3ac52361f88b7746b84eca6.png";